export const getFeatureUnit = (cartFeature, fabricatorData, printContext, locale, quantity) => {
  const dbFeature = cartFeature.dbFeature;
  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && locale === "fr-FR" && printContext.messages["transDoc.units_FR." + dbFeature.sharedFeatureName]) {
    if ((printContext.messages["transDoc.units_FR." + dbFeature.sharedFeatureName] === "pieds carrés") && dbFeature.unit === "Each") {
      return "unité"
    }
    return printContext.messages["transDoc.units_FR." + dbFeature.sharedFeatureName]
  }
  if (dbFeature.unit) {
    let lowercasedUnit = dbFeature.unit.toLowerCase();
    return lowercasedUnit === "each" || lowercasedUnit === "unit"
      ? quantity === 1
        ? printContext.messages["quotingTool.featureInfo.defaultQuantity"]
        : printContext.messages["quotingTool.featureInfo.defaultQuantityMultiple"]
      : dbFeature.unit
  }
  if (cartFeature.isStoneFeature) {
    return printContext.messages["shoppingCart.fetureInCartDefaultQuantitySQFT"]
  }
  return printContext.messages["shoppingCart.fetureInCartDefaultQuantity"]
};

export const getCartItemName = (cartFeature, fabricatorData, printContext, locale) => {
  const dbFeature = cartFeature.dbFeature;
  if (fabricatorData.isLowes || fabricatorData.isCaesarStone) {
    if (locale === "fr-FR" && printContext.messages["transDoc.customDisplayName_FR."+ dbFeature.sharedFeatureName]) {
      return printContext.messages["transDoc.customDisplayName_FR."+ dbFeature.sharedFeatureName]
    } else if (locale === "pl-PL" && printContext.messages["transDoc.customTranslateName_PL."+ dbFeature.sharedFeatureName]) {
      return printContext.messages["transDoc.customTranslateName_PL."+ dbFeature.sharedFeatureName]
    }
  }

  if ((dbFeature.sharedFeatureName === "additionalCartItem.minimumCharge")) {
    if (fabricatorData.isCaesarStone) {
      return `${printContext.messages[dbFeature.sharedFeatureName]} (${cartFeature.fromFeatureName})`
    }
    return printContext.messages[dbFeature.sharedFeatureName]
  }

  if (!cartFeature.getFeatureName) {
    return cartFeature._customDisplayName || cartFeature.customDisplayName || ""
  }

  return cartFeature.getFeatureName()
};
